export default __webpack_public_path__ + "static/sam42_administration-750d82b8d88217f2a76220f18251c2c7.jpg";